// @flow

import React from 'react';
import BrandLogo from 'client/components/brandLogo';
import 'client/styles/account.scss';

type Props = {
  brandName: string,
  siteConfigs: Object,
};

const Hero = ({ brandName, siteConfigs }: Props) => (
  <div className="hero flex-row">
    <div className="center-col-small flex-column">
      <BrandLogo assetBase="/assets" brandName={brandName} siteConfigs={siteConfigs} />
    </div>
  </div>
);

Hero.defaultProps = {
  brandName: 'stride',
};

export default Hero;
